// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.spinner_container_DFjWw {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.spinner_circle_jZCnP {
  width: 64px;
  height: 64px;
  border-radius: 200%;
  display: block;
  background-color: var(--looks-secondary);
  opacity: 0.5;
}

.spinner_logo_IlzyZ {
  transform: scale(1.5, 1.5) translateY(40px);
}

@keyframes spinner_circleA_1_Exlt3 {
  50%,
  0% {
    transform: translate(0px, 22px) scale(0.75, 0.75);
    opacity: 0;
  }

  75% {
    opacity: 0.5;
  }

  100% {
    transform: scale(1.95, 1.95);
  }
}

@keyframes spinner_circleA_2_GqnQL {
  20%,
  0% {
    transform: translate(0px, -52px) scale(0.5, 0.5);
    opacity: 0;
  }

  75% {
    opacity: 0.5;
  }

  100% {
    transform: translate(-25px, -12px) scale(0.96, 0.96);
  }
}

@keyframes spinner_circleA_3_SQw9u {
  30%,
  0% {
    transform: translate(0px, -112px) scale(0.26, 0.26);
    opacity: 0;
  }

  75% {
    opacity: 0.5;
  }

  100% {
    transform: translate(40px, -108px) scale(1.46, 1.46);
  }
}

#spinner_circle_1_lflgo,
#spinner_circle_2_uttcn,
#spinner_circle_3_Ojk42 {
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

#spinner_circle_1_lflgo {
  animation-name: spinner_circleA_1_Exlt3;
}

#spinner_circle_2_uttcn {
  animation-name: spinner_circleA_2_GqnQL;
}

#spinner_circle_3_Ojk42 {
  animation-name: spinner_circleA_3_SQw9u;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-loading-spinner/spinner.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;;IAEE,iDAAiD;IACjD,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,gDAAgD;IAChD,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;;IAEE,mDAAmD;IACnD,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,uCAAyB;AAC3B;;AAEA;EACE,uCAAyB;AAC3B;;AAEA;EACE,uCAAyB;AAC3B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle {\n  width: 64px;\n  height: 64px;\n  border-radius: 200%;\n  display: block;\n  background-color: var(--looks-secondary);\n  opacity: 0.5;\n}\n\n.logo {\n  transform: scale(1.5, 1.5) translateY(40px);\n}\n\n@keyframes circleA_1 {\n  50%,\n  0% {\n    transform: translate(0px, 22px) scale(0.75, 0.75);\n    opacity: 0;\n  }\n\n  75% {\n    opacity: 0.5;\n  }\n\n  100% {\n    transform: scale(1.95, 1.95);\n  }\n}\n\n@keyframes circleA_2 {\n  20%,\n  0% {\n    transform: translate(0px, -52px) scale(0.5, 0.5);\n    opacity: 0;\n  }\n\n  75% {\n    opacity: 0.5;\n  }\n\n  100% {\n    transform: translate(-25px, -12px) scale(0.96, 0.96);\n  }\n}\n\n@keyframes circleA_3 {\n  30%,\n  0% {\n    transform: translate(0px, -112px) scale(0.26, 0.26);\n    opacity: 0;\n  }\n\n  75% {\n    opacity: 0.5;\n  }\n\n  100% {\n    transform: translate(40px, -108px) scale(1.46, 1.46);\n  }\n}\n\n#circle_1,\n#circle_2,\n#circle_3 {\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n}\n\n#circle_1 {\n  animation-name: circleA_1;\n}\n\n#circle_2 {\n  animation-name: circleA_2;\n}\n\n#circle_3 {\n  animation-name: circleA_3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `spinner_container_DFjWw`,
	"circle": `spinner_circle_jZCnP`,
	"logo": `spinner_logo_IlzyZ`,
	"circle_1": `spinner_circle_1_lflgo`,
	"circle1": `spinner_circle_1_lflgo`,
	"circle_2": `spinner_circle_2_uttcn`,
	"circle2": `spinner_circle_2_uttcn`,
	"circle_3": `spinner_circle_3_Ojk42`,
	"circle3": `spinner_circle_3_Ojk42`,
	"circleA_1": `spinner_circleA_1_Exlt3`,
	"circleA1": `spinner_circleA_1_Exlt3`,
	"circleA_2": `spinner_circleA_2_GqnQL`,
	"circleA2": `spinner_circleA_2_GqnQL`,
	"circleA_3": `spinner_circleA_3_SQw9u`,
	"circleA3": `spinner_circleA_3_SQw9u`
};
export default ___CSS_LOADER_EXPORT___;
